import React, { Component, PropTypes } from 'react';

import IngredientsSearchFilters from 'components/IngredientsSearch/IngredientsSearchFilters';
import IngredientsSearchResults from 'components/IngredientsSearch/IngredientsSearchResults';
import IngredientsSearchSelectedItems from 'components/IngredientsSearch/IngredientsSearchSelectedItems';

class IngredientsSearchContent extends Component {

  render() {
    const {
      ingredientsSearch,
      fetchPurchaseHistory,
      fetchListIngredient,
      selectedTab,
      changeSelectedTab,
      changeFilterStatus,
      selectedFilters,
      onIngredientSelect,
      onIngredientRemove,
      selectedIngredients,
      onIngredientQtyUpdate,
      onIngredientUnitUpdate,
      unitTypes,
      updateSortProps,
      updateSearchedTabs,
      fetchProductCatalogue,
      resetTab,
      isBatchRecipe,
      recipeId,
      loading,
      showEditableCustomIngRow,
      onNewCustomIngredientSave,
      cancelAddingNewIngredient,
      commonCustomUom,
      isTryingToCancel,
      userCountry,
      isIngredientReplacement,
      selectedKey,
      isFromNotificationCenter,
      ingredientReplacement
    } = this.props;
    
    return (
      <div className={'flex stretch-flex'}>
        <div className={'flex stretch-flex'}>
          <IngredientsSearchFilters
            fetchPurchaseHistory={ fetchPurchaseHistory }
            fetchListIngredient={ fetchListIngredient }
            selectedTab={ selectedTab }
            ingredientsSearch={ ingredientsSearch }
            changeFilterStatus={changeFilterStatus }
            selectedFilters={selectedFilters }
          />

        <IngredientsSearchResults
          changeSelectedTab={ changeSelectedTab }
          selectedTab={ selectedTab }
          ingredientsSearch={ ingredientsSearch }
          selectedFilters={ selectedFilters }
          onIngredientSelect={ onIngredientSelect }
          unitTypes={ unitTypes }
          updateSortProps={ updateSortProps }
          updateSearchedTabs={ updateSearchedTabs }
          fetchProductCatalogue={ fetchProductCatalogue }
          resetTab={ resetTab }
          isBatchRecipe={ isBatchRecipe }
          recipeId={ recipeId }
          loading={ loading }
          showEditableCustomIngRow={ showEditableCustomIngRow }
          onNewCustomIngredientSave={ onNewCustomIngredientSave }
          cancelAddingNewIngredient={ cancelAddingNewIngredient }
          commonCustomUom={ commonCustomUom }
          userCountry={ userCountry }
          isIngredientReplacement={ isIngredientReplacement }
          selectedKey={ selectedKey }
          isFromNotificationCenter={ isFromNotificationCenter }
          ingredientReplacement={ ingredientReplacement }
        />
          { !isIngredientReplacement ?
            <IngredientsSearchSelectedItems
              selectedIngredients={selectedIngredients}
              onIngredientRemove={onIngredientRemove}
              onIngredientQtyUpdate={onIngredientQtyUpdate}
              onIngredientUnitUpdate={onIngredientUnitUpdate}
              unitTypes={unitTypes}
            />
            : null
          }
          </div>
          { isTryingToCancel ? <div className='loading-layer'></div> : null }
        </div>
    );
  }
}

IngredientsSearchContent.propTypes = {
  fetchPurchaseHistory: PropTypes.func,
  fetchListIngredient: PropTypes.func,
  changeSelectedTab: PropTypes.func,
  selectedTab: PropTypes.string,
  ingredientsSearch: PropTypes.object,
  changeFilterStatus: PropTypes.func,
  selectedFilters: PropTypes.object,
  onIngredientSelect: PropTypes.func,
  onIngredientRemove: PropTypes.func,
  selectedIngredients: PropTypes.array,
  onIngredientQtyUpdate: PropTypes.func,
  onIngredientUnitUpdate: PropTypes.func,
  unitTypes: PropTypes.object,
  isBatchRecipe: PropTypes.bool,
  recipeId: PropTypes.number,
  loading: PropTypes.bool,
  showEditableCustomIngRow: PropTypes.func,
  onNewCustomIngredientSave: PropTypes.func,
  cancelAddingNewIngredient: PropTypes.func,
  commonCustomUom: PropTypes.object,
  isTryingToCancel: PropTypes.bool,
  userCountry: PropTypes.string,
  isIngredientReplacement: PropTypes.bool,
  selectedKey: PropTypes.string,
  isFromNotificationCenter: PropTypes.bool,
  ingredientReplacement: PropTypes.object,
};

export default IngredientsSearchContent;
